import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQ } from "@/data/content";
import { SectionHeading } from "./ui";
import { Reveal } from "./Reveal";

export default function FAQSection() {
  return (
    <section id="faq" className="relative bg-brand-ivory py-20 lg:py-32 grain-overlay">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-12">
        <SectionHeading eyebrow={FAQ.eyebrow} title={FAQ.title} />

        <Reveal delay={2}>
          <Accordion type="single" collapsible className="mt-12 w-full" data-testid="faq-accordion">
            {FAQ.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-brand-bordeaux/12"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-left font-serif text-lg sm:text-xl text-brand-bordeaux hover:no-underline hover:text-brand-wine [&>svg]:text-brand-gold">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-brand-graphite/75">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
